import apiCall from '../utils/api';

export const getReferralAmount = async (type, countryCode, locale) => {
  const url = `/survey/v1/form`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: {
        type,
        countryCode,
        locale,
        action: 'GET_REFERRAL_AMOUNT'
      }

    },
    url
  };
  const res = await apiCall(apiArgs, false);
  return res;
};

export const getReferrerDetails = async (type, locale, referralId) => {
  const url = `/survey/v1/form?referralid=${referralId}`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: {
        type,
        locale,
        action: 'GET_USER_DETAILS',
        referralId
      }
    },
    url,
    isCountryCodeRequired: false
  };
  const res = await apiCall(apiArgs, false);
  return res;
};
